import { SvgIcon } from "@mui/material"

export namespace App {
  export interface UserAuthRequest {
    username: string
    password: string
  }
  export interface UserAuthResult {
    access_token: string
  }

  export interface OIDCAuthResult {
    access_token: string
    id_token: string
    refresh_token?: string
    token_type: string
    expires_in: number
    scope: string
  }

  export interface OIDCUserInfo {
    sub: string
    preferred_username: string
    email?: string
    given_name?: string
    family_name?: string
    roles?: string[]
    realm_access?: {
      roles: string[]
    }
    resource_access?: {
      [key: string]: {
        roles: string[]
      }
    }
  }

  export interface UserAuth {
    authorized: boolean
    exp: number
    role_name: string
    user_id: number
  }

  export enum AuthType {
    STANDARD = "standard",
    OIDC = "oidc",
  }

  export enum AccessPolicy {
    BOT_MONITOR_READ = "BOT_MONITOR_READ",
    USERBOT_TRACKING_READ = "USERBOT_TRACKING_READ",
    USERBOT_TRACKING_WRITE = "USERBOT_TRACKING_WRITE",
    POST_BOT_READ = "POST_BOT_READ",
    POST_BOT_WRITE = "POST_BOT_WRITE",
  }

  export interface AuthState {
    type: AuthType
    token?: string
    refreshToken?: string
    idToken?: string
    userInfo?: OIDCUserInfo | UserAuth
    role: UserRole
    expiresAt?: number
  }

  export interface MenuItem {
    title: string
    url: string
    role: UserRole
    moduleRole?: ModuleName // Новое поле для модульных ролей (OIDC)
    accessPolicy?: AccessPolicy
    exactRole?: boolean
    icon?: typeof SvgIcon
    isOpen?: boolean
  }

  export interface MenuGroup extends Omit<MenuItem, "url"> {
    items: RecursiveMenuItem[]
  }

  export type RecursiveMenuItem = MenuItem | MenuGroup

  export enum UserRole {
    ANON,
    USER,
    MANAGER,
    ADMIN,
  }
  export interface User extends AuthState {}

  export interface RouterState {
    backgroundLocation?: Location
  }

  export enum Gender {
    MAN = "Мужской",
    WOMAN = "Женский",
  }

  // Модульная система ролей для OIDC
  export enum ModuleName {
    ADV = "adv",
    BASIC = "basic",
    HR = "hr",
    MARKETPLACE = "marketplace",
    NC = "nc",
    POST_BOT = "post_bot",
    TG_INVITE_LINKS = "tg_invite_links",
    TG_MAILING = "tg_mailing",
    TG_BOT_CHAT = "tg_bot_chat",
    TG_CHAT_ANALYZE = "tg_chat_analyze",
    SHERLOK = "sherlok",
    STAFF_SCHEDULE = "staff_schedule",
    TGSTAT = "tgstat",
    USERBOT = "userbot",
  }

  export enum AccessType {
    READ = "r",
    WRITE = "w",
  }

  export type ModuleRole = `${ModuleName}:${AccessType}`
}
